var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 602,
    viewBox: "0 0 603 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_310)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301.103,
    cy: 300.599,
    r: 300.599,
    fill: "#172130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.504 0C135.202 0 0.504395 134.773 0.504395 301C0.504395 434.017 86.7409 546.817 206.313 586.574C221.363 589.408 226.881 580.102 226.881 572.101C226.881 564.952 226.631 546.014 226.505 520.931C142.777 539.091 125.118 480.546 125.118 480.546C111.423 445.806 91.6321 436.525 91.6321 436.525C64.3666 417.863 93.7391 418.239 93.7391 418.239C123.965 420.346 139.842 449.242 139.842 449.242C166.681 495.27 210.301 481.976 227.509 474.276C230.218 454.811 237.968 441.542 246.572 434.017C179.725 426.492 109.466 400.606 109.466 285.273C109.466 252.414 121.13 225.574 140.444 204.504C137.058 196.904 126.899 166.302 143.078 124.84C143.078 124.84 168.287 116.763 225.853 155.692C249.933 148.995 275.518 145.684 301.103 145.533C326.688 145.684 352.273 148.995 376.353 155.692C433.543 116.763 458.752 124.84 458.752 124.84C474.931 166.302 464.772 196.904 461.762 204.504C480.951 225.574 492.614 252.414 492.614 285.273C492.614 400.907 422.256 426.366 355.283 433.766C365.818 442.796 375.601 461.257 375.601 489.451C375.601 529.735 375.224 562.092 375.224 571.875C375.224 579.776 380.492 589.182 395.918 586.172C516.343 546.691 602.504 433.816 602.504 301C602.504 134.773 467.732 0 301.504 0",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 602,
    height: 602,
    fill: "white",
    transform: "translate(0.504395)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.e9bc4b1aba7dbbba65d1890843eaaba4.svg";
export { ForwardRef as ReactComponent };